import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { env } from "@/config/env";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "./styles/globals.css";
import App from "./App";

// In preview environments, BFF requests must go directly to the BFF
// (bypassing Firebase Hosting which strips cookies). Set axios defaults
// so generated API clients (orval) and analytics calls use the BFF URL.
const authUrl = env("AUTH_URL");
if (authUrl) {
  axios.defaults.baseURL = authUrl;
  axios.defaults.withCredentials = true;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
